module.exports = __webpack_public_path__ + "media/vctry.b322c227.mp4";